import snackbar from "./snackbar";

function addToCart() {
  $(".products-list__cart-button, .product-detail__cart-btn").on(
    "click",
    function () {
      const url = $(this).parents("div[data-url]").data("url");

      $.ajax({
        type: "POST",
        url: url,
        cache: false,
        // The key needs to match your method's input parameter (case-sensitive).
        data: JSON.stringify({
          id: $(this).data("uid"),
          isProduct: $(this).data("product"),
          quantity: 1,
          modification: 0,
        }),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
      })
        .done((data) => {
          if (data.status == 200) {
            $(".header-vts__cart-dot").text(data.count);
            if (data.count == 0) {
              $(".header-vts__cart-dot").addClass("hidden");
            } else {
              $(".header-vts__cart-dot").removeClass("hidden");
              document.querySelector(".mdc-snackbar span").textContent =
                "The product has been added to the shopping cart";
              snackbar.open();
            }
          } else if (data.status == 202) {
            alert(data.message);
          } else {
            console.log("A problem occurred when sending your request.");
          }
        })
        .fail(function () {
          alert(
            "An error occurred while processing your request. Please try again."
          );
        });
    }
  );
}

export default addToCart;
